var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "embed-home" },
    [
      _c("div", [_vm._v("\n    Welcome to Edbase System Embed\n  ")]),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "m-2",
          attrs: { color: "success", disabled: _vm.embedToken === null },
          on: {
            click: function ($event) {
              _vm.embedToken ? undefined : _vm.getToken()
            },
          },
          scopedSlots: _vm._u([
            {
              key: "loader",
              fn: function () {
                return [_c("span", [_vm._v("Loading...")])]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v("\n    テスト参加\n    ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }